import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Button,
  Checkbox,
  List,
  ListItem,
} from "@chakra-ui/react";
import axios from "axios";
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";
const LedgerTable = () => {
  const [passbookData, setPassbookData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [suggestions, setSuggestions] = useState([]);
  const [llid, setLlid] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [showData, setShowData] = useState(false); // New state to control data visibility
  const [ctotal, setCtotal] = useState([]);
  const [dtotal, setDtotal] = useState([]);
  const [total, settotal] = useState([]);
  // Fixed date setup
  const [fdate, setFdate] = useState("2024-04-01");
  const [tdate, setTdate] = useState(new Date().toISOString().split("T")[0]);
  const [companyData, setCompanyData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  // Retrieve cmp_id from session
  const cmpId = sessionStorage.getItem("cmp_id"); // Default to '1' if not found

  useEffect(() => {
    if (fdate && tdate && llid && showData) {
      // Check if showData is true
      const fetchPassbookData = async () => {
        setLoading(true);
        try {
          const response = await axios.post(
            `${ACCOUNTS_URL}/reports/load_ledger_report.ph`,
            { fdate, tdate, cmp_id: cmpId, llid }
          );
          console.log("====================================");
          console.log(response);
          console.log("====================================");
          if (response.data.success) {
            setPassbookData(response.data.cashbookData);
            setCtotal(response.data.creditTotal || []);
            setDtotal(response.data.debitTotal || []);
            settotal(response.data.totalBalance || []);
          } else {
            console.error(
              "Failed to fetch passbook data:",
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error fetching passbook data:", error);
        }
        setLoading(false);
      };
      fetchPassbookData();
    }
  }, [fdate, tdate, cmpId, llid, showData]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const fetchSuggestions = async () => {
        try {
          const response = await axios.post(
            `${ACCOUNTS_URL}/common/ledger_name.php`,
            { cmp_id: cmpId, fectxt: searchTerm }
          );
          console.log(response);

          if (response.data.status === "success") {
            setSuggestions(response.data.data);
          } else {
            setSuggestions([]);
          }
        } catch (error) {
          console.error("Error fetching search suggestions:", error);
        }
      };
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [searchTerm, cmpId]);

  const handleSuggestionClick = (suggestionId, suggestionName) => {
    setLlid(suggestionId);
    setSearchTerm(suggestionName);
    setSuggestions([]);
  };

  // Filter and pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = Array.isArray(passbookData)
    ? passbookData.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.ceil(
    (Array.isArray(passbookData) ? passbookData.length : 0) / rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (item, index) => {
    const isBold =
      item.sho_name === "Opening Balance" || item.sho_name === "Current Total";

    return (
      <Tr key={item.vouch_no} fontWeight={isBold ? "bold" : "normal"}>
        <Td py="12px" px="8px" textAlign="center">
          {!isBold && <Checkbox />}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.date.split(" ")[0]}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.voucher_no}
        </Td>
        <Td py="12px" px="20px">
          {item.sho_name.split(/(\(.*?\))/g).map((part, idx) => (
            <span
              key={idx}
              style={{ fontStyle: part.startsWith("(") ? "italic" : "normal" }}
            >
              {part}
            </span>
          ))}
        </Td>
        <Td py="12px" px="20px" textAlign="center">
          {item.group_head}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.debit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.credit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.balance}
        </Td>
      </Tr>
    );
  };

  const handleSubmit = () => {
    setShowData(true); // Set to true when submit button is clicked
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setError("User not logged in or user_id not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCompanyDetails = async () => {
        try {
          const response = await fetch(
            `${ACCOUNTS_URL}/settings/company_details.php`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ user_id: userId }),
            }
          );

          const data = await response.json();

          if (data.status === 200) {
            setCompanyData(data.data);
          } else {
            setError("No company found for this user.");
          }
        } catch (err) {
          setError("Error fetching company details.");
        }
      };

      fetchCompanyDetails();
    }
  }, [userId]); // Run when userId is set

  const printVoucher = () => {
    // Detect if the user is on a mobile device
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // Create the content for printing
    const printContent = `
            <html>
                <head>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                        .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                .header h2 { margin: 0; font-size: 24px; }
                .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
                        
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
                <div class="header">
  ${
    companyData?.Company_Name?.startsWith("No") === false
      ? `<h2>${companyData.Company_Name}</h2>`
      : ""
  }

   
    ${
      companyData?.address?.startsWith("No") === false
        ? `<p>${companyData.address}</p>`
        : ""
    }
    ${
      companyData?.Tin?.startsWith("No") === false
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
        : ""
    }
    ${
      companyData?.Email_Id?.startsWith("No") === false
        ? `<p>Email: ${companyData.Email_Id}</p>`
        : ""
    }
</div>
                    <table>
                        <thead>
                            <tr style="background-color: #0073e6; color: white;">
                                <th style="text-align: center; padding: 12px;">Date</th>
                                <th style="text-align: center; padding: 12px;">Voucher No</th>
                                <th style="padding: 12px;">Particulars</th>
                                <th style="text-align: center; padding: 12px;">Type</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                                <th style="text-align: right; padding: 12px;">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${passbookData
                              .map((item) => {
                                const isBold =
                                  item.sho_name === "Opening Balance" ||
                                  item.sho_name === "Current Total";
                                return `
                                    <tr style="font-weight: ${
                                      isBold ? "bold" : "normal"
                                    }; background-color: ${
                                  isBold ? "#f5f5f5" : "white"
                                };">
                                        <td style="padding: 12px; text-align: center;">${
                                          item.date.split(" ")[0]
                                        }</td>
                                        <td style="padding: 12px; text-align: center;">${
                                          item.voucher_no
                                        }</td>
                                        <td style="padding: 12px;">
                                            ${item.sho_name
                                              .split(/(\(.*?\))/g)
                                              .map(
                                                (part, idx) => `
                                                <span style="font-style: ${
                                                  part.startsWith("(")
                                                    ? "italic"
                                                    : "normal"
                                                };">${part}</span>
                                            `
                                              )
                                              .join("")}
                                        </td>
                                        <td style="padding: 12px; text-align: center;">${
                                          item.group_head
                                        }</td>
                                        <td style="padding: 12px; text-align: right;">${
                                          item.debit
                                        }</td>
                                        <td style="padding: 12px; text-align: right;">${
                                          item.credit
                                        }</td>
                                        <td style="padding: 12px; text-align: right;">${
                                          item.balance
                                        }</td>
                                    </tr>
                                `;
                              })
                              .join("")}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

    // Check if it's a mobile device
    if (isMobile) {
      // For mobile devices, open a new window and write the content for printing
      const printWindow = window.open("", "_blank");
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    } else {
      // For desktop, use an iframe for printing
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      // Ensure the iframe is not visible
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      // Access the iframe's document for writing content
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printContent);
      iframeDoc.close();

      // Print from the iframe and remove it afterward
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }
  };

  return (
    <Box mt={3} width="100%" minH="750px" p={1}>
      <Flex
        justify="space-between"
        align="center"
        className="sb"
        p={3}
        wrap={{ base: "wrap", md: "nowrap" }}
      >
        <Flex
          align="center"
          mb={{ base: 4, md: 0 }}
          justify={{ base: "flex-start", md: "center" }}
        >
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            borderColor="#E9EDF4"
          >
            <option value={12}>12</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>

        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={4}
          position="relative"
          width={{ base: "100%", md: "auto" }}
        >
          <Input
            type="date"
            placeholder="From Date"
            value={fdate}
            borderColor="#E9EDF4"
            onChange={(e) => setFdate(e.target.value)}
            width={{ base: "100%", md: "auto" }}
          />
          <Input
            type="date"
            placeholder="To Date"
            value={tdate}
            borderColor="#E9EDF4"
            onChange={(e) => setTdate(e.target.value)}
            width={{ base: "100%", md: "auto" }}
          />
          <Box position="relative" width={{ base: "100%", md: "300px" }}>
            <Input
              type="text"
              placeholder="Search by Name"
              value={searchTerm}
              borderColor="#E9EDF4"
              onChange={(e) => setSearchTerm(e.target.value)}
              width="100%"
            />
            {suggestions.length > 0 && (
              <Box
                position="absolute"
                width="100%"
                bg="white"
                boxShadow="md"
                borderRadius="md"
                mt={1}
                zIndex={10}
                maxHeight="200px"
                overflowY="auto"
              >
                <List spacing={3}>
                  {suggestions.map((suggestion) => (
                    <ListItem
                      key={suggestion.Ldg_id}
                      onClick={() =>
                        handleSuggestionClick(
                          suggestion.Ldg_id,
                          suggestion.L_name
                        )
                      }
                      style={{ cursor: "pointer" }}
                      _hover={{ backgroundColor: "gray.100" }}
                      px={2}
                      py={1}
                    >
                      {suggestion.L_name}
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
        </Stack>

        {/* Submit button */}
        <Button
          onClick={handleSubmit}
          bg="teal"
          color="white"
          mt={{ base: 4, md: 0 }}
        >
          Submit
        </Button>

        <Button colorScheme="teal" onClick={printVoucher}>
          Print
        </Button>
      </Flex>

      <Box
        style={{ overflowX: "auto" }}
        // w={{ base: "367px", md: "100%" }}
        width="100%"
        className={styles.Table}
      >
        {loading ? (
          <Spinner size="xl" />
        ) : showData && fdate && tdate && llid ? (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            borderWidth="1px"
          >
            <Thead>
              <Tr>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  <Checkbox />
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Date
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Voucher No
                </Th>
                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Particulars
                </Th>
                <Th
                  textTransform="none"
                  textAlign="center"
                  fontFamily="'Poppins', sans-serif"
                >
                  Type
                </Th>
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Debit
                </Th>
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Credit
                </Th>
                <Th
                  textAlign="right"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  Balance
                </Th>
              </Tr>
            </Thead>
            <Tbody>{currentData.map(renderRow)}</Tbody>
          </Table>
        ) : (
          <Text p={5} textAlign="center">
            Please set the date range and select a ledger.
          </Text>
        )}
      </Box>
      <Table
        sx={{
          "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
        }}
      >
        <Tbody>
          <Tr>
            {/* <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td> */}
            <Td py="12px" px="20px" textAlign="right" colSpan={5}></Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              Current Balance
            </Td>
            {/* <Td py="12px" px="20px" textAlign="right"></Td> */}
            {/* <Td py="12px" px="30px" textAlign="right"></Td> */}
            <Td py="12px" px="30px" textAlign="right" fontWeight="bold">
              {dtotal} Dr
            </Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              {ctotal} Cr
            </Td>
            {/* <Td py="12px" px="10px" textAlign="right"></Td> */}
          </Tr>
          <Tr>
            {/* <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="12px" textAlign="right"></Td>
            <Td py="12px" px="12px" textAlign="right"></Td> */}
            <Td py="12px" px="20px" textAlign="right" colSpan={5}></Td>

            <Td py="12px" px="20px" textAlign="left" fontWeight="bold">
              Closing Balance
            </Td>
            {/* <Td py="12px" px="20px" textAlign="right"></Td> */}
            {/* <Td py="12px" px="30px" textAlign="right"></Td> */}
            <Td py="12px" px="15px" textAlign="right" fontWeight="bold"></Td>
            <Td py="12px" px="6px" textAlign="right" fontWeight="bold">
              {total}{" "}
            </Td>
          </Tr>
        </Tbody>
      </Table>
      {currentData.length > 0 && (
        <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {currentPage > 1 && (
              <>
                <Button onClick={() => handlePageChange(1)}>1</Button>
                {currentPage > 2 && <Text>...</Text>}
              </>
            )}
            <Button backgroundColor="teal" color="white">
              {currentPage}
            </Button>
            {currentPage < totalPages - 1 && (
              <>
                <Text>...</Text>
                <Button onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Button>
              </>
            )}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default LedgerTable;
